import { B2B_PACKAGE_TYPE, C2C_PACKAGE_TYPE, DOCUMENTS_PACKAGE_TYPE, STANDARD_PACKAGE_TYPE } from "../../data/static-data";

export const isStandardPackage = (packageType) => {
    return packageType === STANDARD_PACKAGE_TYPE;
}

export const isB2BPackage = (packageType) => {
    return packageType === B2B_PACKAGE_TYPE;
}


export const isDocumentsPackage = (packageType) => {
    return packageType === DOCUMENTS_PACKAGE_TYPE;
}

export const isC2CPackage = (packageType) => {
    return packageType === C2C_PACKAGE_TYPE;
}

export const isStandardOrB2BOrC2CPackage = (packageType) => {
    return isStandardPackage(packageType) || isB2BPackage(packageType) || isC2CPackage(packageType);
}